import endPoints from './endPoints.json';

export default function getBaseUrl() {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'PRODUCTION':
      return endPoints.BASEURL;
    default:
      return endPoints.BASEURL;
  }
};